module.exports = __webpack_public_path__ + "static/media/propic-8.75e41d42.png";